import { ReactElement } from 'react';
import { Collapse } from '@mui/material';

import { useDashboardVariantV2CarrierContext } from '../../Context';
import { DashboardVariantV2CarrierZoneSaturationCollapseContent } from './styles';
import DashboardVariantV2CarrierZoneSaturationCollapseTable from './Table';

const DashboardVariantV2CarrierZoneSaturationCollapse = (): ReactElement => {
  const {
    data: {
      zoneSaturation: {
        expand: { value: expand },
      },
    },
  } = useDashboardVariantV2CarrierContext();

  return (
    <Collapse in={expand}>
      <DashboardVariantV2CarrierZoneSaturationCollapseContent>
        <DashboardVariantV2CarrierZoneSaturationCollapseTable />
      </DashboardVariantV2CarrierZoneSaturationCollapseContent>
    </Collapse>
  );
};

export default DashboardVariantV2CarrierZoneSaturationCollapse;
